module.exports = __webpack_public_path__ + "img/book(11).aa11ce31.png";